import { getCurrentConnectionInfo } from 'portal-sdk';
import { UseQueryOptions } from 'react-query';

import { PortalConnection } from 'bones/utils/portal/usePortalConnectionByIndex';
import { usePortalConnectionsWithDemo } from 'bones/utils/portal/usePortalConnectionsWithDemo';

export const usePortalConnection = (
  options?: UseQueryOptions<any>
): PortalConnection | null => {
  const portalConnections = usePortalConnectionsWithDemo(options);
  const connectionIndex = getCurrentConnectionInfo(window)?.connectionIndex;
  const portalConnection = portalConnections?.find(
    ({ index }) => index === connectionIndex
  );
  return portalConnection || null;
};
